import { defineComponent, reactive } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import { PopupWrapper, withLoading } from '@hems/component';
import { StormCoverService } from '@hems/service';
import { DateHelper } from '@hems/util';
import { STORM_MESSAGE, STORM_COVER_BUTTON } from '@hems/util/src/constant';
export default defineComponent({
    name: 'SevereWeatherPopup',
    components: {
        PopupWrapper,
    },
    emits: ['open', 'close'],
    async setup(props, { emit }) {
        const store = useStore();
        const stormService = new StormCoverService(window.axiosInstance.axios);
        const stormData = reactive({
            siteId: store.state.device.baseDeviceInfo?.site_id,
            data: store.state.storm,
        });
        const closePopup = (e) => {
            e.preventDefault();
            emit('close');
        };
        const stopWatchSeenInfo = withLoading(async () => {
            try {
                if (stormData.siteId) {
                    await stormService.sendSeenStormInfoFlag(stormData.siteId).then(() => emit('close'));
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        async function openControl() {
            stopWatchSeenInfo();
            emit('open');
        }
        function convertToStormCoverDate(date) {
            return DateHelper.getLocalDate(date, { isTime: true, isSecond: false, needUtcConvert: true });
        }
        const isNewNotification = stormData.data.stormCoverEvent.some((event) => event.stormNotiFlag === 0);
        // 오늘 로컬기준 시간이 악천후 이벤트 시작 48시간 이내에 있는지 확인
        function isChargeStartTime(eventStart, eventEnd) {
            const today = Number(new Date());
            const hours48InMilliseconds = 48 * 60 * 60 * 1000;
            const twoDaysBeforeStorm = Number(eventStart) - hours48InMilliseconds;
            return moment(today).isBetween(twoDaysBeforeStorm, eventEnd);
        }
        return {
            closePopup,
            openControl,
            stormData,
            convertToStormCoverDate,
            isChargeStartTime,
            stopWatchSeenInfo,
            isNewNotification,
            STORM_MESSAGE,
            STORM_COVER_BUTTON,
        };
    },
});
